/**
 * Created by 58 on 2017/2/15.
 */

var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('./../../template/msg/minicard-msg-item.html');
var config = require('./../../global/config');
var getImgParams = require('./../../global/utils').convertImgParams;
var XssFilter = require('../../../lib/XssFilter');
var utils = require('../../global/utils');
var isEmpty = utils.isEmpty;

var MiniCardMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);
};

MiniCardMsgItem.prototype = Object.create(BaseMsgItem.prototype);
MiniCardMsgItem.prototype.renderContent = function () {
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  var content = msg.content;
  var element = this._element;
  var title = element.find(".im-minicard-title");
  var a = element.find(".im-minicard-content");
  var detail = element.find('.im-minicard-detail');
  var extend = element.find(".im-minicard-extend");
  var img = element.find(".im-minicard-img");
  var defHref = 'javascript:void(0)';

  /*  var params = {
   width: content.card_picture_w,
   height: content.card_picture_h,
   baseWidth: 100,
   unit: 'px'
   };
   var imgParams = getImgParams(params);*/

  a.attr("href", content.card_action_pc_url || defHref);
  /*a.css({
   'padding-left': (parseFloat(imgParams.width.split('px')[0]) + 10) + 'px',
   'min-height': imgParams.height
   });*/
  // xssFilter,将'<'替换成’&lt;将'>'替换成&gt;
  title.text(XssFilter.doFilter(content.card_title));
  if (content && content.card_picture_url && content.card_picture_url !== '') {
    img.attr('src', content.card_picture_url);
  } else {
    img.css('display', 'none');
    a.css('paddingLeft', 0);
  }
  /* img.css(
   {
   'height': imgParams.height,
   'width': imgParams.width
   });*/

  // content
  if (content.card_content && content.card_content !== '') {
    detail.text(content.card_content);
  } else {
    detail.css('display', 'none');
  }

  // 有标签
  var cardLabelsArr = content.card_labels;
  if (cardLabelsArr && cardLabelsArr.length > 0) {
    var labelsNode = $('<ul></ul>').addClass('im-minicard-labels');
    for (var i = 0; i < cardLabelsArr.length; i++) {
      if (!isEmpty(cardLabelsArr[i])) {
        var labelNode = $('<li></li>').text(cardLabelsArr[i]);
        labelsNode.append(labelNode);
      }
    }
    extend.append(labelsNode);
  }

  // 有价格
  if (content.card_price) {
    var priceNode = $('<span></span>').text(content.card_price).addClass('im-minicard-price');
    extend.append(priceNode);
  }

	element.find('.im-msg-content').on('click', '[href]', function(e) {
		e.preventDefault();
		var url_jump = $(this).attr('href');
		if (url_jump != defHref) {
      utils.openPage(url_jump);
		}
	});
};

module.exports = MiniCardMsgItem;